import { patientService } from "../../services/patientService";
import { allergyService } from "../../services/allergyService";
import { implantService } from "../../services/implantService";
import { medicineService } from "../../services/medicineService";
import { medicineDoseService } from "../../services/medicineDoseService";
import { surgeryTypeService } from "../../services/surgeryTypeService";
import { documentTypeService } from "../../services/documentTypeService";
import { recordCategoryService } from "../../services/recordCategoryService";
import { rehabFacilityService } from "../../services/rehabFacilityService";
import { userService } from "../../services/userService";
import { diseaseService } from "../../services/diseaseService";
import { rvService } from "../../services/rvService";
import { doctorService } from "../../services/doctorService";
import { specialtyService } from "../../services/specialtyService";

import { patientFormData, patientFields } from "../../types/patient";
import { allergyFormData, allergyFields } from "../../types/allergy";
import { implantFormData, implantFields } from "../../types/implant";
import { medicineFormData, medicineFields } from "../../types/medicine";
import { medicineDoseFormData, medicineDoseFields } from "../../types/medicineDose";
import { surgeryTypeFormData, surgeryTypeFields } from "../../types/surgeryType";
import { documentTypeFormData, documentTypeFields } from "../../types/documentType";
import { diseaseFormData, diseaseFields } from "../../types/disease";
import { recordCategoryFormData, recordCategoryFields } from "../../types/recordCategory";
import { rehabFacilityFormData, rehabFacilityFields } from "../../types/rehabFacility";
import { doctorFormData, doctorFields } from "../../types/doctor";
import { userFormData, userFields } from "../../types/user";
import { appointmentFields, appointmentFormDataKeys} from "../../types/appointment";
import { specialtyFormData, specialtyFields } from "../../types/specialty";
import { rvFormData, rvFields } from "../../types/rv";

export type FieldDefinition = {
  readonly name: string;
  readonly label: string;
  readonly type: string;
  readonly required?: boolean;
};
export type Category =
  | "patient"
  | "surgery"
  | "rv"
  | "user"
  | "medicine"
  | "medicineDose"
  | "rehabCenter"
  | "implant"
  | "allergy"
  | "disease"
  | "documentType"
  | "historyType"
  | "medicineDose"
  | "doctor"
  | "specialty";

export const servicesMap: Record<Category, any> = {
  patient: patientService,
  allergy: allergyService,
  implant: implantService,
  medicine: medicineService,
  medicineDose: medicineDoseService,
  surgery: surgeryTypeService,
  documentType: documentTypeService,
  historyType: recordCategoryService,
  rehabCenter: rehabFacilityService,
  user: userService,
  rv: rvService,
  disease: diseaseService,
  doctor : doctorService,
  specialty : specialtyService
};

export { servicesMap as searchServiceMap, servicesMap as deleteServiceMap, servicesMap as updateServiceMap };

// 1. Για τα πεδία της φόρμας (strings)
export const EntityFormFields: Partial<Record<Category, readonly string[]>> = {
  patient: patientFormData,
  allergy: allergyFormData, 
  implant: implantFormData,
  medicine: medicineFormData,
  medicineDose: medicineDoseFormData,
  surgery: surgeryTypeFormData,
  disease: diseaseFormData,
  documentType: documentTypeFormData,
  historType: recordCategoryFormData,
  rehabCenter: rehabFacilityFormData,
  user: userFormData,
  rv: rvFormData,
  doctor :  doctorFormData,
  specialty : specialtyFormData
};

// 2. Για τις στήλες του πίνακα (με Labels)
export const EntityFieldsMap: Partial<Record<Category,readonly FieldDefinition[]>> = {
  allergy: allergyFields,
  patient: patientFields,
  implant: implantFields,
  medicine: medicineFields,
  medicineDose: medicineDoseFields,
  surgery: surgeryTypeFields,
  documentType: documentTypeFields,
  historyType: recordCategoryFields,
  rehabCenter: rehabFacilityFields,
  user: userFields,
  disease: diseaseFields,
  specialty : specialtyFields,
  doctor: doctorFields(),
  rv : rvFields,
};

 export const categoryLabels: Record<Category | string, string> = {
  patient: "Ασθενής",
  rv: "Ραντεβού",
  surgery: "Χειρουργείο",
  medicine: "Φαρμακευτική Αγωγή",
  medicineDose: "Δόσεις Φαρμάκων",
  user: "Χρήστες",
  implant: "Εμφυτεύματα",
  allergy: "Αλλεργίες",
  disease: "Ασθένειες",
  documentType: "Τύπος Εξετάσεων",
  historyType: "Τύπος Ιστορικού",
  doctor: "Ιατροί",
  specialty: "Ιατρικές Ειδικότητες",
  rehabCenter: "Κέντρα Αποκατάστασης",
};